import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requireRoles = null }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Not authenticated - redirect to login
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !['admin', 'owner'].includes((user.role || '').toLowerCase())) {
    // Authenticated but not admin/owner — redirect home (no admin content shown)
    return <Navigate to="/" replace />;
  }

  if (Array.isArray(requireRoles) && requireRoles.length > 0) {
    const role = (user.role || '').toLowerCase();
    if (!requireRoles.map((r) => r.toLowerCase()).includes(role)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
